import { Injectable } from '@angular/core';
import { ICustomerGenericService, IHIPGenericService, IGenericService } from '../interfaces/GenericService';
import { Endpoints as HIPEndpoints } from '@huge-monorepo/hip/services';
import { Endpoints as CustomerEndpoints } from '@huge-monorepo/portal/config';
@Injectable({
    providedIn: 'root',
})
export class SharedGenericSingletonService<T extends ICustomerGenericService | IHIPGenericService> {
    public service: T;
    public isHIP: boolean = false;
    public isCustomer: boolean = false;
    public apiLink: string;
    public isLightMode: boolean;
    public path: string;
    public endpoints: HIPEndpoints | CustomerEndpoints;

    setGenericService(service: any): void {
        this.service = service;
    }

    setIsHIP(isHIP: boolean): void {
        this.isHIP = isHIP;
    }

    setIsCustomer(isCustomer: boolean): void {
        this.isCustomer = isCustomer;
    }

    setEndpoints(endpoints: HIPEndpoints | CustomerEndpoints): void {
        this.endpoints = endpoints;
    }

    getEndpoints(): HIPEndpoints | CustomerEndpoints {
        return this.endpoints;
    }

    getGenericService(): any {
        if (!this.service) {
            throw new Error('App service has not been set');
        }
        return this.service;
    }

    getIsHIP(): boolean {
        return this.isHIP;
    }

    getIsCustomer(): boolean {
        return this.isCustomer;
    }

    setApiLink(link: string): void {
        this.apiLink = link;
    }

    getApiLink(): string {
        return this.apiLink;
    }

    setIsLightMode(isLight: boolean): void {
        this.isLightMode = isLight;
    }

    getIsLightMode(): boolean {
        return this.isLightMode;
    }

    setPath(): void {
        if (this.isLightMode) {
            this.path = 'assets/navigation/light-mode/'
        } else {
            this.path = 'assets/navigation/dark-mode/'
        }
    }

    getPath(): string;
    getPath(lightMode: boolean): string;
    getPath(lightMode?: boolean): string {
        if (lightMode === undefined) {
            return this.path;
        }
        return lightMode ? 'assets/navigation/light-mode/' : 'assets/navigation/dark-mode/';
    }
}
